import React from 'react';

import './style.scss';

interface IAlertPageProps {
    title: React.ReactNode;
    description: React.ReactNode;
}

export const AlertPage = ({title, description, children}: React.PropsWithChildren<IAlertPageProps>) => {

    return (
        <div className="AlertPage">
            <h1 className="AlertPage__title">{title}</h1>
            <p className="AlertPage__description">{description}</p>
            <div className="AlertPage__description">
                {children}
            </div>
        </div>
    );
};
